var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass: "top-bar",
      class: { "top-bar-hide": _vm.playing },
      attrs: { id: "header" }
    },
    [
      _c("div", { staticClass: "top-bar_nav" }, [
        _c(
          "div",
          { staticClass: "top-wrap" },
          [
            _c(
              "div",
              {
                staticClass: "fl top-bar_logo",
                on: { click: _vm.backToIndex }
              },
              [
                _c("img", {
                  attrs: { src: require("assets/images/logo.svg"), alt: "" }
                })
              ]
            ),
            _c("div", { staticClass: "top-bar_hidden fr" }, [
              _c(
                "button",
                {
                  staticClass: "icon-menu",
                  class: { closed: _vm.expanding },
                  on: {
                    click: function($event) {
                      ;(_vm.expanding = !_vm.expanding),
                        (_vm.detailExpanding = false),
                        (_vm.idx = null)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "svgMenu line1" }),
                  _c("span", { staticClass: "svgMenu line2" }),
                  _c("span", { staticClass: "svgMenu line3" })
                ]
              )
            ]),
            _c(
              "transition",
              {
                attrs: {
                  name: "fade",
                  "enter-active-class": "fadeInRight",
                  "leave-active-class": "fadeOutRight"
                }
              },
              [
                _vm.expanding
                  ? _c("div", { staticClass: "fr top-bar_nav_list" }, [
                      _c(
                        "ul",
                        [
                          _vm._l(_vm.items, function(item, index) {
                            return _c(
                              "li",
                              {
                                key: item.id,
                                staticClass: "fl pad top-bar_navLi"
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "top-bar_nav_btn",
                                    class: {
                                      detailExpanding:
                                        _vm.idx === index ? true : false,
                                      light: _vm.idx === index ? true : false
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.select(index)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.lang === "cn"
                                          ? item.name
                                          : item.name_en
                                      ) + "\n              "
                                    )
                                  ]
                                ),
                                _c(
                                  "transition",
                                  {
                                    attrs: {
                                      name: "fade",
                                      "enter-active-class": "fadeInDown",
                                      "leave-active-class": "fadeOutUp"
                                    }
                                  },
                                  [
                                    (_vm.idx === index
                                    ? true
                                    : false)
                                      ? _c(
                                          "ul",
                                          {
                                            staticClass: "top-bar_nav_btn_child"
                                          },
                                          _vm._l(item.child, function(menu) {
                                            return _c("li", { key: menu.id }, [
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "menu-btn",
                                                  on: {
                                                    click: function($event) {
                                                      ;(_vm.detailExpanding = !_vm.detailExpanding),
                                                        (_vm.idx = null),
                                                        _vm.$router.push({
                                                          path: menu.url,
                                                          query: {
                                                            lang: _vm.lang
                                                          }
                                                        }),
                                                        (_vm.expanding = !_vm.expanding)
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.lang === "cn"
                                                          ? menu.name
                                                          : menu.name_en
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            ])
                                          }),
                                          0
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ],
                              1
                            )
                          }),
                          _c("li", { staticClass: "fl top-bar_language" }, [
                            _c(
                              "button",
                              {
                                staticClass: "top-bar_lang",
                                on: {
                                  click: function($event) {
                                    return _vm.toggleLang("en")
                                  }
                                }
                              },
                              [_vm._v("EN")]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "top-bar_lang",
                                on: {
                                  click: function($event) {
                                    return _vm.toggleLang("cn")
                                  }
                                }
                              },
                              [_vm._v("CN")]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "top-bar_lang_phone china",
                                class: { lang_active: _vm.lang === "en" },
                                on: {
                                  click: function($event) {
                                    return _vm.toggleLang("cn")
                                  }
                                }
                              },
                              [_vm._v("中文")]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "top-bar_lang_phone eng",
                                class: { lang_active: _vm.lang === "cn" },
                                on: {
                                  click: function($event) {
                                    return _vm.toggleLang("en")
                                  }
                                }
                              },
                              [_vm._v("English")]
                            )
                          ])
                        ],
                        2
                      )
                    ])
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _c(
        "transition",
        {
          attrs: {
            name: "fade",
            "enter-active-class": "fadeIn",
            "leave-active-class": "fadeOut"
          }
        },
        [
          _vm.detailExpanding
            ? _c("div", {
                staticClass: "top-bar_menu",
                style: { height: _vm.winHeight - 60 + "px" },
                on: {
                  click: function($event) {
                    ;(_vm.detailExpanding = !_vm.detailExpanding),
                      (_vm.idx = null)
                  }
                }
              })
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51865f33", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51865f33","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/CommonHeader.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-51865f33","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/CommonHeader.vue
// module chunks = 15